import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c93c240"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "largeim" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/statics/images/test/test20.jpg" })
], -1))
const _hoisted_2 = { class: "contentbg" }
const _hoisted_3 = { class: "container py-5" }
const _hoisted_4 = { class: "d-md-flex justify-content-between align-items-center" }
const _hoisted_5 = { class: "breadcrumb" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 当前位置： ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "" }, "首页", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" > ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" > ")
const _hoisted_10 = { style: {"color":"#f03 !important"} }
const _hoisted_11 = {
  class: "content container",
  style: {"white-space":"pre-line","word-wrap":"break-word","text-align":"left","word-break":"break-all"}
}
const _hoisted_12 = { class: "content-main" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = { style: {"width":"100%"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "bottom" }, null, -1))
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "page row align-items-center" }
const _hoisted_18 = { class: "col-5" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "page-spans" }, "<", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "page-spans2" }, "∣", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-2",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("a", null, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "svg",
      src: "statics/ll/img/btncent.svg"
    })
  ])
], -1))
const _hoisted_22 = { class: "col-5 page-next" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "page-spannext2" }, "∣", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "page-spannext" }, ">", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goLink()))
            }, _toDisplayString(_ctx.newsTitle.name), 1),
            _hoisted_9,
            _withDirectives(_createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goLink()))
            }, _toDisplayString(_ctx.newsTitle.title1) + " >", 513), [
              [_vShow, !_ctx.show]
            ]),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.newsData.title), 1)
          ]),
          _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goArticle(3))),
            class: "btn btn-back"
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.show1 == true ? "返回" : "Return"), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("div", _hoisted_13, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.newsData.title), 1),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", null, _toDisplayString(_ctx.show1 ? "发布时间" : "Time") + ":" + _toDisplayString(_ctx.newsData.createTime), 1)
            ]),
            _hoisted_15
          ], 512), [
            [_vShow, _ctx.show]
          ]),
          _createElementVNode("div", {
            innerHTML: _ctx.newsData.content
          }, null, 8, _hoisted_16),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("a", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goArticle(1))),
                style: {"display":"flex","align-items":"center"}
              }, [
                _hoisted_19,
                _hoisted_20,
                _createTextVNode(_toDisplayString(_ctx.indexPage == 0
                  ? _ctx.show1
                    ? "第一页"
                    : "First"
                  : _ctx.pageNoData[_ctx.indexPage - 1].title), 1)
              ])
            ]),
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("a", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goArticle(2))),
                style: {"display":"flex","align-items":"center"}
              }, [
                _createTextVNode(_toDisplayString(_ctx.indexPage == _ctx.pageNoData.length - 1
                  ? _ctx.show1
                    ? "最后一页"
                    : "Last"
                  : _ctx.pageNoData[_ctx.indexPage + 1].title), 1),
                _hoisted_23,
                _hoisted_24
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}